import React, { useState, useEffect } from "react";

// Components
import Sidebar from "../../../components/Sidebar";
import Main from "./Main";
import Form from "./Form";

// Utils
import { getDataWithComp, getAlert } from "../../../../utils/SamuiUtils";
import { InitialDataTbSetSize } from "../../../../model/InitialData/InitialDataTbSetSize";

const TbSetSize = () => {
    const [mode, setMode] = useState("");
    const [dataMasterList, setDataMasterList] = useState([]);
    const [selectedData, setSelectedData] = useState(null);
    const [formData, setFormData] = useState(InitialDataTbSetSize());

    useEffect(() => {
        const init = async () => {
            try {
                setMode("S");
                fetchRealtime();
            } catch (error) {
                getAlert("FAILED", error.message);
            }
        };
        init();
    }, []);

    const initialize = async () => {
        try {
            setMode("S");
            fetchRealtime();
        } catch (error) {
            getAlert("FAILED", error.message);
        }
    };

    const fetchRealtime = async () => {
        try {
            const masterList = await getDataWithComp(
                "Tb_Set_ItmSize",
                "Order By Size_Code"
            );
            if (masterList && masterList.length > 0) {
                setDataMasterList(masterList);
            } else {
                setDataMasterList([]);
            }
        } catch (error) {
            getAlert("FAILED", error.message);
        }
    };

    const onPageInsert = () => {
        setMode("I");
    };

    const onRowSelected = (item) => {
        setMode("U");
        setFormData({
            comp_id: item.Comp_Id,
            Size_Id: item.Size_Id,
            Size_Code: item.Size_Code,
            Size_Name: item.Size_Name,
            Size_Status: item.Size_Status,
        });
        setSelectedData(item);
    };

    return (
        <div className="TbSetSize">
            <div className="wrapper">
                <Sidebar />
                <div className="main-panel">
                    <div className="container">
                        <div className="page-inner">
                            {mode === "S" ? (
                                <Main
                                    masterList={dataMasterList}
                                    name={"ข้อมูลไซส์"}
                                    onPageInsert={() => onPageInsert()}
                                    onRowSelected={(item) => onRowSelected(item)}
                                />
                            ) : (
                                <Form
                                    callInitialize={initialize}
                                    mode={mode}
                                    name={"ข้อมูลไซส์"}
                                    formData={formData}
                                    setFormData={setFormData}
                                    selectedData={selectedData}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TbSetSize;
